import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getStatsOverview } from '../../services/adminService';

const conversionRate = (leads) => {
  if (!leads || !leads.total) return 0;
  return Math.round((leads.converted / leads.total) * 100);
};

const AdminOverview = () => {
  const [stats, setStats] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        setLoading(true);
        const data = await getStatsOverview();
        if (!cancelled) setStats(data);
      } catch (err) {
        if (!cancelled) setError(err.response?.data?.message || 'Eroare la incarcarea statisticilor.');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) return <div className="admin-empty">Se incarca statisticile…</div>;
  if (error) return <div className="admin-empty">⚠️ {error}</div>;
  if (!stats) return null;

  const u = stats.users || {};
  const l = stats.leads || {};

  return (
    <>
      <div className="admin-section">
        <div className="admin-section-header">
          <h2>Utilizatori înregistrați</h2>
          <Link to="/admin/users" className="admin-link">
            Vezi lista →
          </Link>
        </div>
        <div className="admin-card-grid">
          <div className="admin-card">
            <div className="admin-card-label">Total utilizatori</div>
            <div className="admin-card-value">{u.total ?? 0}</div>
            <div className="admin-card-sub">{u.registeredLast7Days ?? 0} în ultimele 7 zile</div>
          </div>
          <div className="admin-card accent-emerald">
            <div className="admin-card-label">Plătit (abonament activ)</div>
            <div className="admin-card-value">{u.paid ?? 0}</div>
            <div className="admin-card-sub">
              {u.total ? Math.round(((u.paid || 0) / u.total) * 100) : 0}% din total
            </div>
          </div>
          <div className="admin-card">
            <div className="admin-card-label">Fără abonament</div>
            <div className="admin-card-value">{u.free ?? 0}</div>
            <div className="admin-card-sub">cont creat dar nu plătit</div>
          </div>
        </div>
      </div>

      <div className="admin-section">
        <div className="admin-section-header">
          <h2>Funnel lead-uri (invitații)</h2>
          <Link to="/admin/leads" className="admin-link">
            Vezi lista →
          </Link>
        </div>
        <div className="admin-card-grid">
          <div className="admin-card accent-indigo">
            <div className="admin-card-label">Lead-uri noi</div>
            <div className="admin-card-value">{l.new ?? 0}</div>
            <div className="admin-card-sub">de procesat</div>
          </div>
          <div className="admin-card accent-amber">
            <div className="admin-card-label">Contactați</div>
            <div className="admin-card-value">{l.contacted ?? 0}</div>
            <div className="admin-card-sub">în lucru</div>
          </div>
          <div className="admin-card accent-emerald">
            <div className="admin-card-label">Convertiți</div>
            <div className="admin-card-value">{l.converted ?? 0}</div>
            <div className="admin-card-sub">{l.convertedLast7Days ?? 0} în ultimele 7 zile</div>
          </div>
          <div className="admin-card accent-rose">
            <div className="admin-card-label">Respinși</div>
            <div className="admin-card-value">{l.rejected ?? 0}</div>
            <div className="admin-card-sub">nu interesați / spam</div>
          </div>
        </div>

        <div className="admin-card-grid">
          <div className="admin-card">
            <div className="admin-card-label">Rată de conversie</div>
            <div className="admin-card-value">{conversionRate(l)}%</div>
            <div className="admin-card-sub">convertiți / total lead-uri</div>
          </div>
          <div className="admin-card">
            <div className="admin-card-label">Lead-uri (ultimele 7 zile)</div>
            <div className="admin-card-value">{l.submittedLast7Days ?? 0}</div>
            <div className="admin-card-sub">cereri proaspete</div>
          </div>
          <div className="admin-card">
            <div className="admin-card-label">Total lead-uri</div>
            <div className="admin-card-value">{l.total ?? 0}</div>
            <div className="admin-card-sub">istoric complet</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminOverview;
